// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__mBtnc","Success":"Button_Success__1x9xb","Danger":"Button_Danger__Tnl_j"};